import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type TicketDeleteData = AnyObject;

export type TicketDeleteResponse = TicketDeleteData;

export interface TicketDelete {
  id: string;
}

export const ticketDelete = (payload: TicketDelete): Action<TicketDelete> => ({
  type: actions.ticketDeleteTrigger.toString(),
  payload,
});

export const ticketDeleteClear = (): Action => ({
  type: actions.ticketDeleteClear.toString(),
});

export function* ticketDeleteRequestSaga({ payload }: Action<TicketDelete>) {
  yield put({
    type: actions.ticketDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.ticketDeleteError.toString(),
      payload: {
        message: 'TicketDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/tickets/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TicketDeleteData, TicketDeleteResponse>(
    response,
    actions.ticketDeleteSuccess.toString(),
    actions.ticketDeleteError.toString(),
    false,
    (ticketDeleteData) => ticketDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.ticketDeleteTrigger.toString(),
    defaultProcessingSaga(
      ticketDeleteRequestSaga,
      {
        error: actions.ticketDeleteError.toString(),
        locationCancel: actions.ticketDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.ticketDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.ticketDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.ticketDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.ticketDeleteErrorReset.toString(),
    });
  });
}
